import { connect } from 'react-redux'
import solidRateForm from '../ui/forms/solidRateForm'
import { setSolidRateValues } from '../../store/actions/solidRateActions'

const mapStateToProps = state => ({
    formValues: state.formulas.solidRate
})

const mapDispatchToProps = dispatch => {
    return {
        formToState: (val) => {
            dispatch(
                setSolidRateValues(val)
            )
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(solidRateForm)